import { render, staticRenderFns } from "./DashBoxVelocityTable.vue?vue&type=template&id=2b9d84c8&"
import script from "./DashBoxVelocityTable.vue?vue&type=script&lang=js&"
export * from "./DashBoxVelocityTable.vue?vue&type=script&lang=js&"
import style0 from "./DashBoxVelocityTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9d84c8')) {
      api.createRecord('2b9d84c8', component.options)
    } else {
      api.reload('2b9d84c8', component.options)
    }
    module.hot.accept("./DashBoxVelocityTable.vue?vue&type=template&id=2b9d84c8&", function () {
      api.rerender('2b9d84c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DashBoxVelocityTable.vue"
export default component.exports